module.exports = __webpack_public_path__ + "static/media/skyscanner_RGB_white.3ac58d82.svg";